import React from 'react';
import { observer,inject } from 'mobx-react';
import LoadingSpinner from '../LoadingSpinner';
import ButtonSpinner from '../ButtonSpinner';
import { Button } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Utils from '../../Utils';
import renderHTML from 'react-render-html';

@inject('announcementStore')
@observer
export default class AnnouncementList extends React.Component {
    componentDidMount(){
        this.props.announcementStore.GetAnnouncements();
    }
    dateFormater(cell,row){
        return Utils.Dates.ToString("dd/mm/yyyy",cell);
    }
    editButtonFormatter(cell,row){
        return(<Button onClick={()=>{
            this.props.announcementStore.ToggleAddAnnouncementModal(row.AnnouncementId);
        }} >Edit</Button>);
    }
    deleteButtonFormatter(cell,row){
        return(<Button key={"btn-"+row.AnnouncementId} onClick={()=>{
            this.props.announcementStore.AnnouncementIdToDelete = row.AnnouncementId;
            this.props.announcementStore.DeleteAnnouncement();
        }} >Delete <ButtonSpinner key={"spnr-"+row.AnnouncementId} IsLoading={this.props.announcementStore.IsDeletingAnnouncement && row.AnnouncementId === this.props.announcementStore.AnnouncementIdToDelete} /></Button>);
    }
    contentFormatter(cell,row){
        return(<div  >{renderHTML(row.Content)}</div>);
    }
   render(){
      if(!this.props.announcementStore.LoadingAnnouncements){
        return(<BootstrapTable data={this.props.announcementStore.Announcements} striped={true} hover={true}>
        <TableHeaderColumn dataField="AnnouncementId" isKey={true} hidden={true}  >Id</TableHeaderColumn>
        <TableHeaderColumn dataField="AnnouncementDate" dataSort={true} dataFormat={this.dateFormater} >Announced On</TableHeaderColumn>
        <TableHeaderColumn dataField="Content"  dataFormat={this.contentFormatter} >Announcement</TableHeaderColumn>
        <TableHeaderColumn dataField="ExpiresOn"  dataFormat={this.dateFormater}>Expires On</TableHeaderColumn>
        <TableHeaderColumn dataFormat={this.editButtonFormatter.bind(this)}  >Edit</TableHeaderColumn>
        <TableHeaderColumn dataFormat={this.deleteButtonFormatter.bind(this)}  >Delete</TableHeaderColumn>
    </BootstrapTable>);
      }
      else{
        return(<LoadingSpinner/>);
      }
   }
}


// WEBPACK FOOTER //
// ./src/components/Announcements/AnnouncementList.js